export function scrollOffset(containerSelector, offset = 70) {
  document.querySelectorAll(containerSelector).forEach(container => {
    container
      .querySelectorAll('a[href^="#"]')
      .forEach(link => {
        link.addEventListener("click", function(e) {
          e.preventDefault();
          const targetId = this.getAttribute("href").slice(1);
          const target = document.getElementById(targetId);
          if (!target) return;

          const topOfElement =
            target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: topOfElement - offset,
            behavior: "smooth"
          });
        });
      });
  });

  function scrollToHash() {
    const { hash } = window.location;
    if (!hash) return;

    const targetId = hash.slice(1);
    const target = document.getElementById(targetId);
    if (!target) return;

    const topOfElement =
      target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: topOfElement - offset,
      behavior: "auto"
    });
  }

  window.addEventListener("load", scrollToHash);
}